export enum Profiles {
  AGENCY = 'agency',
  SUPERVISOR = 'supervisor',
  POINT_SALE = 'sale_staff',
  CLIENT = 'client',
}

export const profilesTitles: Record<Profiles, string> = {
  [Profiles.AGENCY]: 'Agencia',
  [Profiles.SUPERVISOR]: 'Supervisor',
  [Profiles.POINT_SALE]: 'PPV',
  [Profiles.CLIENT]: 'Cliente',
};

export const profileList = [
  Profiles.AGENCY,
  Profiles.CLIENT,
  Profiles.POINT_SALE,
  Profiles.SUPERVISOR,
];
